/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2025.
 *  Title: Progetto.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Modules/Progetto.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 22/12/25, 17:42;
 *  Updated at: 22/12/25, 17:42;
 *  ```
 */

import {EnvironmentModel} from "../BaseEnvironments/Model";

export var Progetto = (): EnvironmentModel => {
  var env: EnvironmentModel = {
    Modules: {
      "Progetto": true
    },
    ProgettiAddon:{
      badges: [
        { nome: 'Non Approvati', oggetti: ['nonAccettate'], },
        { nome: 'Approvati', oggetti: ['Accettate'], },
        { nome: 'Completati', oggetti: ['chiuse'] },
        { nome: 'Annullati', oggetti: ['annullate'] },
        { nome: 'Totale Offerto', oggetti: ['offerto'], },
        { nome: 'Totale Accettato', oggetti: ['accettato'] },
        { nome: 'Valore Lavorato', oggetti: ['lavorato'] },
      ],
      TipiProgetto:[
        {
          nome: 'Progetto',
          id: "P",
          colore: "#1baa03",
          restRoute: "/progetti/progetti",
          capacita: [],
          HideVoci:true,
          defaultFilter:{tipoOfferta: "P"},
          headers:[
            {nome: "Codice", oggetti:['codice'], class: 'col-md-12'},
            {nome: "Oggetto", oggetti:['oggetto'], class: 'col-md-12'},
            {
              nome: 'Creazione',
              oggetti: ['data_creazione'],
              inputType: 'date',
              class: 'col-md-12',
            },
            {
              nome: 'Offerta',
              oggetti: ['data_emissione'],
              inputType: 'date',

              class: 'col-md-12',
            },
            {
              nome: 'Accettazione',
              oggetti: ['data_accettazione'],
              inputType: 'date',
              class: 'col-md-3',
            },
          ],
          CampiOfferta :[
            {
              modificabile: true,
              nome: 'Oggetto:',
              oggetti: ['oggetto'],
              inputType: 'text',
              titleClass: 'control-label col-form-label',
              class: 'col-lg-3',
              visibleifProhibited: true
            },
            {
              modificabile: true,
              nome: 'Codice Progetto:',
              oggetti: ['codice'],
              inputType: 'text',
              titleClass: 'control-label col-form-label',
              class: 'col-lg-3',
              placeholder: 'Codice Progetto:',
              visibleifProhibited: true
            },
            {
              modificabile: true,
              nome: 'Offerta.Responsabile',
              oggetti: ['manager'],
              inputType: 'singleDropdown',
              source: 'managers',
              internalOutput: 'managerObject',
              OnFilter: 'filtroManager',
              OnChange: 'OnManagerChange',
              placeholder: 'Seleziona',
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'id',
                textField: 'fullName',
                searchPlaceholderText: "inserire almeno 3 caratteri",
                allowSearchFilter: true,
                allowRemoteDataSearch: true,
              },
              titleClass: 'control-label col-form-label',
              class: 'col-lg-3',
              visibleifProhibited: true
            },
            {
              prevDivClass: "col-md-12",
              modificabile: true,
              nome: 'Offerta.Creazione',
              oggetti: ['data_creazione'],
              inputType: 'date',
              titleClass: 'control-label col-form-label',
              class: 'col-md-3',
              visibleifProhibited: true
            },
            {
              modificabile: true,
              nome: 'Offerta.Offerta',
              oggetti: ['data_emissione'],
              inputType: 'date',
              titleClass: 'control-label col-form-label',
              class: 'col-md-3',
              visibleifProhibited: true
            },
            {
              modificabile: true,
              nome: 'Offerta.Accettazione',
              oggetti: ['data_accettazione'],
              inputType: 'date',
              titleClass: 'control-label col-form-label',
              class: 'col-md-3',
              visibleifProhibited: true
            },
            // {
            //   modificabile: true,
            //   nome: 'Offerta.Conferma',
            //   oggetti: ['data_conferma'],
            //   inputType: 'date',
            //   titleClass: 'control-label col-form-label',
            //   class: 'col-md-3',
            //   visibleifProhibited: true
            // },
            {
              prevDivClass: "col-md-12",
              modificabile: true,
              nome: 'Note',
              oggetti: ['note'],
              inputType: 'textarea',
              titleClass: 'control-label col-form-label',
              class: 'col-md-6',
              visibleifProhibited: true
            },
            {

              modificabile: true,
              nome: 'Completato:',
              oggetti: ['chiuso'],
              inputType: 'checkbox',
              titleClass: 'control-label col-form-label',
              class: 'col-md-1',
              visibleifProhibited: true,
            },
            {
              modificabile: true,
              nome: 'Annullato:',
              oggetti: ['annullato'],
              inputType: 'checkbox',
              titleClass: 'control-label col-form-label',
              class: 'col-md-1',
              visibleifProhibited: true,
            },
            {
              modificabile: true,
              nome: 'Data Annullamento:',
              oggetti: ['dataAnnullato'],
              inputType: 'date',
              titleClass: 'control-label col-form-label',
              class: 'col-md-2',
              visibleifProhibited: true,
            },
          ]
        },
      ]
    },

    Menu: [
      {
        module: "Progetti",
        path: "progetti/ordini/P/T",
        title: 'Progetti',
        icon: "mdi mdi-calendar-multiple-check",
        capacita: ["menu-progetti", "is-cliente-ordine"]
      },
    ],
  }
  return env;

}
